module.exports = require('../../dist/writers/endpoint.js')
